import stringUtils from '../../utils/string';

export const subscribeUnsavedFormChangesActions = () => {
	const actions = {};

	const registerUserAction = (formName, action) => {
		if (stringUtils.isNullOrEmpty(formName)) return;

		return (actions[formName] = action);
	};

	const unregisterUserAction = (formName) => {
		if (stringUtils.isNullOrEmpty(formName)) return;

		if (!actions[formName]) {
			return console.error(`You didn't register any action for page or form with name: ${formName}`);
		}

		return delete actions[formName];
	};

	const runUserAction = (formName) => {
		if (stringUtils.isNullOrEmpty(formName)) return;

		if (!actions[formName]) {
			return console.error(`You didn't register any action for page or form with name: ${formName}`);
		}

		return actions[formName]();
	};

	const registerPageAction = (pageName, action) => {
		if (stringUtils.isNullOrEmpty(pageName)) return;

		const name = `${pageName}Page`;
		return registerUserAction(name, action);
	};

	const unregisterPageAction = (pageName) => {
		if (stringUtils.isNullOrEmpty(pageName)) return;

		const name = `${pageName}Page`;
		return unregisterUserAction(name);
	};

	const runPageAction = (pageName) => {
		if (stringUtils.isNullOrEmpty(pageName)) return;

		const name = `${pageName}Page`;
		return runUserAction(name);
	};

	return {
		runUserAction,
		registerUserAction,
		unregisterUserAction,
		registerPageAction,
		unregisterPageAction,
		runPageAction,
	};
};
